import { FaFacebookSquare, FaLinkedin, FaTwitterSquare } from "react-icons/fa";
const socialNetwork = [
  {
    title: "Facebook",
    url: "//facebook.com",
    icon:<FaFacebookSquare/>
  },
  {
    title: "Twitter",
    url: "//twitter.com",
    icon:<FaTwitterSquare/>
  },
  {
    title: "Linkedin",
    url: "//linkedin.com",
    icon:<FaLinkedin/>
  },
];

export default socialNetwork;
